import { theme } from '@innovamat/glimmer-components';
import { type IconType } from '@innovamat/glimmer-icons';
import { Group } from '../types/group';
import { ResourceType } from '../types/resource-type';
import type { SessionResourceType } from '../types/session';

export const getColorByGroup = (type: Group) => {
  switch (type) {
    case Group.escalfem:
      return {
        dark: theme.colors.purple['01'],
        medium: theme.colors.purple['02'],
        light: theme.colors.purple['03'],
      };
    case Group.activitat:
      return {
        dark: theme.colors.orange['01'],
        medium: theme.colors.orange['02'],
        light: theme.colors.orange['03'],
      };
    default:
      return {
        dark: theme.colors.blue['01'],
        medium: theme.colors.blue['02'],
        light: theme.colors.blue['03'],
      };
  }
};

export const getPlayerIcon = (resource: SessionResourceType): IconType => {
  switch (resource.type) {
    case ResourceType.vimeo:
      return 'PlayerIcon';
    case ResourceType.manipulativeenvironment:
      return 'ManipulativeEnvironmentIcon';
    case ResourceType.applet:
      return 'AppletIcon';
    case ResourceType.genially:
    case ResourceType.pdf:
      return 'ChecklistIcon';
    default:
      return 'TouchIcon';
  }
};

export function isTouchDevice() {
  return (
    !!(
      typeof window !== 'undefined' &&
      ('ontouchstart' in window ||
        ((window as any).DocumentTouch &&
          typeof document !== 'undefined' &&
          document instanceof (window as any).DocumentTouch))
    ) ||
    !!(
      typeof navigator !== 'undefined' &&
      (navigator.maxTouchPoints || (navigator as any).msMaxTouchPoints)
    )
  );
}
